import { createSlice,PayloadAction } from "@reduxjs/toolkit";
import { Signatories } from "../../types/signatories";
import { UsersData } from "../../types/address";
import { AssignDocumentsAllocation } from "../../types/allocation";

interface RootState{
    signatories:Signatories[],
    usersdata:UsersData[],
    assignDocuments:AssignDocumentsAllocation[],
    status:'idle'|'loading'|'succeeded'|'failed';
    error:string|null
}

const initialState:RootState={
    signatories:[],
    usersdata:[],
    assignDocuments:[],
    status:'idle',
    error:null
}

export const signatoriesSlice=createSlice({
    name:"signatories",
    initialState,
    reducers:{
        setSignatories:(state,action:PayloadAction<Signatories[]>)=>{
            state.status='succeeded';
            state.signatories=action.payload;
            state.error=null
        },
        setusersdata:(state,action:PayloadAction<UsersData[]>)=>{
            state.usersdata=action.payload;
            state.status='succeeded';
            state.error=null
        },
        setAssignDocuments:(state,action:PayloadAction<AssignDocumentsAllocation[]>)=>{
            state.assignDocuments=action.payload;
            state.status='succeeded';
            state.error=null;
        },
        clearAssignDocuments:(state)=>{
            state.assignDocuments=[];
            state.status='succeeded';
            state.error=null;
          }
    }
})


export const {setSignatories,setusersdata,setAssignDocuments,clearAssignDocuments} = signatoriesSlice.actions;

export default signatoriesSlice.reducer;